import React, { useEffect } from "react";
import {
    Button,
    Dropdown,
    Flex,
    Input,
    InputLabel,
    Loader,
    RadioGroup,
    Text,
} from "@fluentui/react-northstar";
import Card from "..";
import TimeJobAndSalaryContent, {
    Title,
} from "./Components/TimeJobAndSalaryContent";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useEmployeeFolderIsMe } from "../../../store";
import { useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import {
    _api_get_leave_policy,
    _api_get_package_type_standard_ids,
    _api_update_contract,
    _api_update_my_personal_information,
} from "../../../api";
import { ALERTS_TYPES_EMPLOYEE_FOLDER, QUERY_KEY } from "../../../constants";
import {
    ACTIVITY_RATE,
    CUMUL_CONGES,
    RTT_POLICY,
    SALARY_PERIOD,
    SALARY_TYPE,
} from "../../../../../constants/lists";
import styled from "styled-components";
import { ROLES_CODE, roles_access } from "../../../../../constants/roles";
import { ErrorMessage } from "../../../../../common/styles";
import { DialogConfirmationUpdateHoursWorked } from "../../DialogConfirmationUpdateHoursWorked/DialogConfirmationUpdateHoursWorked";
import Planning from "./Components/Planning";
import { comparerJSON } from "../../../utils";
import { useSearchParams } from "react-router-dom";
import SliderTabs from "../../../../../components/shared/SliderTabs";

const TimeJobAndSalary = ({ contract_data }) => {
    const clientQuery = useQueryClient();

    const [searchParams, setSearchParams] = useSearchParams();

    const [modeUpdate, setModeUpdate] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState({
        visible: false,
        message_hours_worked: "",
        message_leave_policy: "",
        message_timetable: "",
    });

    const isHR = roles_access({
        usersPrivileges: [ROLES_CODE.hr],
    });

    const method = useForm({
        mode: "onChange",
        defaultValues: {
            package_type: contract_data?.package_type?.id,
            salary_currency: contract_data?.salary?.currency,
            timetable: contract_data?.timetable,
            hour_count_per_week: Number(contract_data?.hour_count_per_week),
            day_count_per_year: Number(contract_data?.day_count_per_year),
            cumulate_balance_prorata:
                contract_data?.cumulate_balance_prorata === true ? 1 : 2,
        },
    });

    // GET leave policy
    const { data: leave_policy_data, isLoading: leave_policy_data_loading } =
        useQuery(
            [QUERY_KEY + "::get_leave_policy"],
            () => _api_get_leave_policy(),
            {
                refetchOnWindowFocus: false,
            }
        );

    const { mutate: mutate_update_contract, isLoading: is_loading_mutate } =
        useMutation((data) => _api_update_contract(data));

    // control button radio
    const partTimePercentage = method.watch("part_time_percentage");
    const selectedRadio = method.watch("cumul_des_conges");

    useEffect(() => {
        if (modeUpdate) {
            method.trigger("hour_count_per_week");
            method.trigger("day_count_per_year");
        }
    }, [contract_data, modeUpdate, method.watch("package_type")]);

    // Effet pour mettre à jour cumul_des_conges lorsque part_time_percentage change
    // useEffect(() => {
    //     if (partTimePercentage === 100) {
    //         method.setValue("cumul_des_conges", 2); // Sélectionne automatiquement id=2
    //     } else {
    //         method.setValue("cumul_des_conges", 1); // Sélectionne automatiquement id=1
    //     }
    // }, [partTimePercentage]);
    // control button radio

    if (leave_policy_data_loading) {
        return <Loader content="chargement des données" />;
    }

    const package_type = method.watch(
        "package_type",
        contract_data?.package_type?.id
    );

    const _setModeUpdate = (bool) => {
        if (!bool) {
            method.reset();
        }
        return setModeUpdate(bool);
    };

    const onSubmit = (data) => {
        const newData = {
            ...data,
            activity_rate: data?.part_time_percentage === 100 ? 1 : 2,
            cumulate_balance_prorata: data.cumulate_balance_prorata === 1,
        };
        mutate_update_contract(
            {
                ...data,
                activity_rate: data?.part_time_percentage === 100 ? 1 : 2,
                leave_policy_id: data?.leave_policy?.id,
                rtt_policy: data?.rtt_policy?.id,
                part_time_percentage: parseFloat(data?.part_time_percentage),
                // cumulate_balance_prorata: data.cumulate_balance_prorata,
                // cumulate_balance_prorata:
                //     data.cumulate_balance_prorata === 1 &&
                //     data?.part_time_percentage !== 100,
                cumulate_balance_prorata: data.cumulate_balance_prorata === 1,

                // Convertit en booléen directement
            },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        // show alert
                        setSearchParams({
                            alert: ALERTS_TYPES_EMPLOYEE_FOLDER.contract_update_timejob_salary_success,
                        });
                        clientQuery.resetQueries([QUERY_KEY + "::contract"]);
                        _setModeUpdate(false);
                    }
                    return;
                },
            }
        );
    };

    const _handleSubmit = (e) => {
        e.preventDefault();
        const old_hour_count_per_week = Number(
            contract_data?.hour_count_per_week
        );
        const new_hour_count_per_week = Number(
            method.getValues("hour_count_per_week")
        );

        const old_leave_policy_id = contract_data?.leave_policy?.id;
        const new_leave_policy_id = method.getValues("leave_policy")?.id;

        const old_timetable = contract_data?.timetable;
        const new_timetable = method.getValues("timetable");

        const is_alter_timetable = !comparerJSON(old_timetable, new_timetable);

        const content_message = {
            message_hours_worked:
                package_type === 1 &&
                old_hour_count_per_week !== new_hour_count_per_week ? (
                    <div>
                        La <u>modification des heures travaillées</u> par
                        semaine <b>impactera la déclaration du temps</b> future
                        de la personne concernée."
                    </div>
                ) : (
                    ""
                ),
            message_leave_policy:
                old_leave_policy_id !== new_leave_policy_id ? (
                    <div>
                        <u>
                            Les soldes de congés seront automatiquement
                            transférés
                        </u>
                        <b> dans les types de congés correspondants</b> de la
                        nouvelle politique d’absence.
                    </div>
                ) : (
                    ""
                ),
            message_timetable: is_alter_timetable ? (
                <div>
                    <u>L'emploi du temps</u> défini par le manager{" "}
                    <b>sera réinitialisé</b>
                </div>
            ) : (
                ""
            ),
        };

        if (
            (package_type === 1 &&
                old_hour_count_per_week !== new_hour_count_per_week) ||
            old_leave_policy_id !== new_leave_policy_id ||
            is_alter_timetable
        ) {
            return setOpenConfirmationDialog((state) => ({
                ...state,
                visible: true,
                ...content_message,
            }));
        } else {
            method.handleSubmit(onSubmit)();
        }
    };

    // * MODE UPDATE
    // * MODE UPDATE
    // * MODE UPDATE
    if (modeUpdate) {
        // * Format activity_rate
        const PACKAGE_TYPE = [
            {
                key: 1,
                label: "Heures",
                value: 1,
            },
            {
                key: 2,
                label: "Jours",
                value: 2,
            },
        ];

        const format_activity_rates = ACTIVITY_RATE.map((ar) => {
            return {
                key: ar?.id,
                label: ar?.name,
                value: ar.id,
                title: ar?.name,
                styles: {
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                },
            };
        });

        let default_activity_rate_find = format_activity_rates?.filter(
            (ar) => ar?.value === contract_data?.activity_rate?.id
        );

        default_activity_rate_find = default_activity_rate_find?.length
            ? default_activity_rate_find[0]?.value
            : format_activity_rates[0]?.value;

        const format_leave_policy_data = leave_policy_data?.map((lp) => {
            return {
                id: lp?.id,
                key: lp?.id,
                header: lp?.name,
            };
        });

        const default_leave_policy_data = format_leave_policy_data?.find(
            (el) => el?.id === contract_data?.leave_policy?.id
        );

        const format_rtt_policy = RTT_POLICY?.map((rtt) => {
            return {
                id: rtt?.id,
                header: rtt?.name,
            };
        });

        const cumul_conges = CUMUL_CONGES.map((el) => {
            return {
                key: el?.id,
                label: el?.name,
                value: el?.id,
                title: el?.name,
                styles: {
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                },
            };
        });

        const salary_period = SALARY_PERIOD.map((el) => {
            return {
                key: el?.id,
                label: el?.name,
                value: el?.id,
                title: el?.name,
                styles: {
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                },
            };
        });

        const [_, ...rest] = salary_period;

        // * Verify the country => if FR or CHF
        const is_fr = contract_data?.contract_country?.toLowerCase() === "fr";
        const is_ch = contract_data?.contract_country?.toLowerCase() === "ch";

        return (
            <Flex fill styles={{ maxWidth: "440px" }} column>
                <Card column>
                    <DialogConfirmationUpdateHoursWorked
                        openConfirmationDialog={openConfirmationDialog.visible}
                        onCancel={() =>
                            setOpenConfirmationDialog((state) => ({
                                ...state,
                                visible: false,
                            }))
                        }
                        content={
                            <Flex column gap="gap.small">
                                <Text
                                    content={
                                        openConfirmationDialog.message_hours_worked
                                    }
                                />
                                <Text
                                    content={
                                        openConfirmationDialog.message_leave_policy
                                    }
                                />
                                <Text
                                    content={
                                        openConfirmationDialog.message_timetable
                                    }
                                />
                            </Flex>
                        }
                        onConfirm={() => {
                            method.handleSubmit(onSubmit)();
                            setOpenConfirmationDialog((state) => ({
                                ...state,
                                visible: false,
                            }));
                            return;
                        }}
                    />
                    <Card.EditTitle
                        content={"Modification de Temps de travail"}
                        onClose={() => _setModeUpdate(false)}
                    />
                    <Card.Body
                        content={
                            <FormProvider {...method}>
                                <form onSubmit={method.handleSubmit(onSubmit)}>
                                    <Flex column gap="gap.medium">
                                        {is_fr && (
                                            <Flex>
                                                <Title content="Activité contractuelle" />
                                            </Flex>
                                        )}
                                        {/* slider tabs  */}
                                        <Flex gap="gap.medium" fill column>
                                            {is_fr && (
                                                <Flex column>
                                                    {/* <InputLabel content="Forfait" /> */}
                                                    <Controller
                                                        control={method.control}
                                                        name="package_type"
                                                        render={({
                                                            field: {
                                                                onChange,
                                                                onBlur,
                                                            },
                                                        }) => {
                                                            return (
                                                                <Flex fill>
                                                                    <SliderTabs
                                                                        tabs={[
                                                                            "Forfait Heures ",
                                                                            "Forfait Jours ",
                                                                        ]}
                                                                        defaultActiveIndex={
                                                                            contract_data
                                                                                ?.package_type
                                                                                ?.id ===
                                                                            1
                                                                                ? 0
                                                                                : 1
                                                                        }
                                                                        onChange={(
                                                                            i
                                                                        ) => {
                                                                            const format_value =
                                                                                PACKAGE_TYPE[
                                                                                    i
                                                                                ]
                                                                                    .value;
                                                                            // method.setValue(
                                                                            //     "package_type",
                                                                            //     format_value
                                                                            // );
                                                                            onChange(
                                                                                format_value
                                                                            );
                                                                        }}
                                                                        onBlur={
                                                                            onBlur
                                                                        }
                                                                    />
                                                                </Flex>
                                                            );
                                                        }}
                                                    />
                                                </Flex>
                                            )}
                                            <Flex>
                                                {package_type === 1 ? ( // heures
                                                    <>
                                                        <Flex column>
                                                            <Flex
                                                                gap="gap.large"
                                                                vAlign="start"
                                                            >
                                                                {/* heure travaillées par semaine  */}
                                                                <Flex column>
                                                                    <Controller
                                                                        control={
                                                                            method.control
                                                                        }
                                                                        name="hour_count_per_week"
                                                                        rules={{
                                                                            required:
                                                                                {
                                                                                    value: true,
                                                                                    message:
                                                                                        "Ce champ est obligatoire",
                                                                                },
                                                                            min: {
                                                                                value: 1,
                                                                                message:
                                                                                    "Ce champ doit être supérieur à 0",
                                                                            },
                                                                        }}
                                                                        defaultValue={Number(
                                                                            contract_data?.hour_count_per_week
                                                                        )}
                                                                        render={({
                                                                            field: {
                                                                                onChange,
                                                                            },
                                                                        }) => {
                                                                            return (
                                                                                <Input
                                                                                    styles={{
                                                                                        width: "245px",
                                                                                    }}
                                                                                    defaultValue={Number(
                                                                                        contract_data?.hour_count_per_week
                                                                                    )}
                                                                                    onChange={(
                                                                                        _,
                                                                                        i
                                                                                    ) =>
                                                                                        onChange(
                                                                                            Number(
                                                                                                i?.value
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                    type="number"
                                                                                    label="Heures travaillées / semaine"
                                                                                    error={
                                                                                        method
                                                                                            .formState
                                                                                            .errors
                                                                                            ?.hour_count_per_week
                                                                                            ?.message
                                                                                    }
                                                                                    fluid
                                                                                    onWheel={(
                                                                                        e
                                                                                    ) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        e.target.blur();
                                                                                        setTimeout(
                                                                                            () => {
                                                                                                e.target.focus();
                                                                                            },
                                                                                            0
                                                                                        );
                                                                                        return false;
                                                                                    }}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    <ErrorMessage
                                                                        content={
                                                                            method
                                                                                .formState
                                                                                .errors
                                                                                ?.hour_count_per_week
                                                                                ?.message
                                                                        }
                                                                    />
                                                                </Flex>
                                                                {/* taux d'activité  */}
                                                                <Flex
                                                                    styles={{
                                                                        width: "100px",
                                                                    }}
                                                                >
                                                                    <Controller
                                                                        control={
                                                                            method.control
                                                                        }
                                                                        name="part_time_percentage"
                                                                        defaultValue={
                                                                            contract_data?.part_time_percentage
                                                                        }
                                                                        rules={{
                                                                            required:
                                                                                {
                                                                                    value: true,
                                                                                    message:
                                                                                        "Ce champ est obligatoire",
                                                                                },

                                                                            max: {
                                                                                value: 100,
                                                                                message:
                                                                                    "La valeur ne peut pas dépasser 100",
                                                                            },
                                                                            min: {
                                                                                value: 0,
                                                                                message:
                                                                                    "La valeur ne peut pas être négative",
                                                                            },
                                                                        }}
                                                                        render={({
                                                                            field: {
                                                                                onChange,
                                                                                onBlur,
                                                                                value,
                                                                                ref,
                                                                            },
                                                                        }) => (
                                                                            <>
                                                                                <InputSuffix
                                                                                    fluid
                                                                                    type="number"
                                                                                    icon={{
                                                                                        content:
                                                                                            "%",
                                                                                    }}
                                                                                    onChange={(
                                                                                        e,
                                                                                        i
                                                                                    ) => {
                                                                                        const newValue =
                                                                                            Math.min(
                                                                                                100,
                                                                                                Math.max(
                                                                                                    0,
                                                                                                    i?.value
                                                                                                )
                                                                                            ); // Bloque entre 0 et 100
                                                                                        onChange(
                                                                                            newValue
                                                                                        );
                                                                                    }}
                                                                                    value={
                                                                                        value
                                                                                    }
                                                                                    label={
                                                                                        <Text
                                                                                            styles={{
                                                                                                whiteSpace:
                                                                                                    "nowrap",
                                                                                            }}
                                                                                            content="Taux d'activité"
                                                                                        />
                                                                                    }
                                                                                    defaultValue={
                                                                                        contract_data?.part_time_percentage
                                                                                    }
                                                                                    error={
                                                                                        !!method
                                                                                            .formState
                                                                                            .errors
                                                                                            .part_time_percentage
                                                                                    }
                                                                                />

                                                                                {/* Affichage du message d'erreur sous l'input */}
                                                                                {method
                                                                                    .formState
                                                                                    .errors
                                                                                    .part_time_percentage && (
                                                                                    <Text
                                                                                        styles={{
                                                                                            color: "red",
                                                                                            fontSize:
                                                                                                "12px",
                                                                                            marginTop:
                                                                                                "4px",
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            method
                                                                                                .formState
                                                                                                .errors
                                                                                                .part_time_percentage
                                                                                                .message
                                                                                        }
                                                                                    </Text>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </Flex>
                                                            </Flex>

                                                            <ErrorMessage
                                                                content={
                                                                    method
                                                                        .errors
                                                                        ?.hour_count_per_week
                                                                        ?.message
                                                                }
                                                            />
                                                        </Flex>
                                                    </>
                                                ) : (
                                                    // jours
                                                    <>
                                                        <Flex
                                                            gap="gap.large"
                                                            vAlign="start"
                                                        >
                                                            <Flex column>
                                                                <Input
                                                                    {...method.register(
                                                                        "day_count_per_year",
                                                                        {
                                                                            required:
                                                                                {
                                                                                    value: true,
                                                                                    message:
                                                                                        "Ce champ est obligatoire",
                                                                                },
                                                                            min: {
                                                                                value: 1,
                                                                                message:
                                                                                    "Ce champ doit être supérieur à 0",
                                                                            },
                                                                            setValueAs:
                                                                                (
                                                                                    v
                                                                                ) =>
                                                                                    parseFloat(
                                                                                        v
                                                                                    ),
                                                                        }
                                                                    )}
                                                                    error={
                                                                        method
                                                                            .formState
                                                                            .errors
                                                                            ?.day_count_per_year
                                                                            ?.message
                                                                    }
                                                                    defaultValue={Number(
                                                                        contract_data?.day_count_per_year
                                                                    )}
                                                                    type="number"
                                                                    label="Nombre de jours travaillés par an"
                                                                    fluid
                                                                />
                                                                <ErrorMessage
                                                                    content={
                                                                        method
                                                                            .formState
                                                                            .errors
                                                                            ?.day_count_per_year
                                                                            ?.message
                                                                    }
                                                                />
                                                            </Flex>
                                                            <Flex
                                                                styles={{
                                                                    width: "100px",
                                                                }}
                                                            >
                                                                <Controller
                                                                    control={
                                                                        method.control
                                                                    }
                                                                    name="part_time_percentage"
                                                                    defaultValue={
                                                                        contract_data?.part_time_percentage
                                                                    }
                                                                    rules={{
                                                                        required:
                                                                            {
                                                                                value: true,
                                                                                message:
                                                                                    "Ce champ est obligatoire",
                                                                            },

                                                                        max: {
                                                                            value: 100,
                                                                            message:
                                                                                "La valeur ne peut pas dépasser 100",
                                                                        },
                                                                        min: {
                                                                            value: 0,
                                                                            message:
                                                                                "La valeur ne peut pas être négative",
                                                                        },
                                                                    }}
                                                                    render={({
                                                                        field: {
                                                                            onChange,
                                                                            onBlur,
                                                                            value,
                                                                            ref,
                                                                        },
                                                                    }) => (
                                                                        <>
                                                                            <InputSuffix
                                                                                fluid
                                                                                type="number"
                                                                                icon={{
                                                                                    content:
                                                                                        "%",
                                                                                }}
                                                                                onChange={(
                                                                                    e,
                                                                                    i
                                                                                ) => {
                                                                                    const newValue =
                                                                                        Math.min(
                                                                                            100,
                                                                                            Math.max(
                                                                                                0,
                                                                                                i?.value
                                                                                            )
                                                                                        ); // Bloque entre 0 et 100
                                                                                    onChange(
                                                                                        newValue
                                                                                    );
                                                                                }}
                                                                                value={
                                                                                    value
                                                                                }
                                                                                label={
                                                                                    <Text
                                                                                        styles={{
                                                                                            whiteSpace:
                                                                                                "nowrap",
                                                                                        }}
                                                                                        content="Taux d'activité"
                                                                                    />
                                                                                }
                                                                                defaultValue={
                                                                                    contract_data?.part_time_percentage
                                                                                }
                                                                                error={
                                                                                    !!method
                                                                                        .formState
                                                                                        .errors
                                                                                        .part_time_percentage
                                                                                }
                                                                            />

                                                                            {/* Affichage du message d'erreur sous l'input */}
                                                                            {method
                                                                                .formState
                                                                                .errors
                                                                                .part_time_percentage && (
                                                                                <Text
                                                                                    styles={{
                                                                                        color: "red",
                                                                                        fontSize:
                                                                                            "12px",
                                                                                        marginTop:
                                                                                            "4px",
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        method
                                                                                            .formState
                                                                                            .errors
                                                                                            .part_time_percentage
                                                                                            .message
                                                                                    }
                                                                                </Text>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                />
                                                            </Flex>
                                                        </Flex>
                                                    </>
                                                )}
                                            </Flex>
                                        </Flex>

                                        <Flex
                                            fill
                                            styles={{
                                                // width: "300px",
                                                overflow: "hidden",
                                            }}
                                            gap="gap.medium"
                                            column
                                        >
                                            <Title content="Jours travaillés" />

                                            <Planning
                                                mode="writing"
                                                timetable={method.watch(
                                                    "timetable"
                                                )}
                                            />
                                        </Flex>

                                        <Flex column gap="gap.medium">
                                            <Title content="Droits aux vacances" />
                                            {/* politique d'absence  */}

                                            <Flex column>
                                                <InputLabel
                                                    content={
                                                        "Politique d'absence"
                                                    }
                                                />
                                                <Controller
                                                    name="leave_policy"
                                                    control={method.control}
                                                    defaultValue={
                                                        default_leave_policy_data
                                                    }
                                                    rules={{
                                                        required: {
                                                            value: true,
                                                            message:
                                                                "ce champs est boligatoire",
                                                        },
                                                    }}
                                                    render={({
                                                        field: { onChange },
                                                    }) => {
                                                        return (
                                                            <Dropdown
                                                                items={
                                                                    format_leave_policy_data
                                                                }
                                                                defaultValue={
                                                                    default_leave_policy_data
                                                                }
                                                                onChange={(
                                                                    _,
                                                                    i
                                                                ) =>
                                                                    onChange(
                                                                        i?.value
                                                                    )
                                                                }
                                                                error={
                                                                    method
                                                                        .errors
                                                                        ?.leave_policy
                                                                        ?.message
                                                                }
                                                                fluid
                                                                placeholder="Choisir la politique d'absence"
                                                                checkable
                                                                getA11ySelectionMessage={{
                                                                    onAdd: (
                                                                        item
                                                                    ) =>
                                                                        `${item} has been selected.`,
                                                                }}
                                                            />
                                                        );
                                                    }}
                                                />
                                            </Flex>
                                        </Flex>

                                        {/* Cumul des congés  */}

                                        <Flex column>
                                            <InputLabel content="Cumul des congés" />
                                            <Controller
                                                name="cumulate_balance_prorata"
                                                control={method.control}
                                                defaultValue={
                                                    contract_data?.cumulate_balance_prorata
                                                        ? 1
                                                        : 2
                                                } // Correspond à l'id de CUMUL_CONGES
                                                render={({
                                                    field: { onChange, value },
                                                }) => {
                                                    return (
                                                        <RadioGroup
                                                            defaultCheckedValue={
                                                                value
                                                            }
                                                            // Sélectionne 2 si is_fr est vrai
                                                            checkedValue={
                                                                method.watch(
                                                                    "part_time_percentage"
                                                                ) === 100
                                                                    ? 2
                                                                    : value
                                                            }
                                                            onCheckedValueChange={(
                                                                _,
                                                                i
                                                            ) => {
                                                                console.log({
                                                                    i: i.value,
                                                                });
                                                                onChange(
                                                                    i?.value
                                                                ); // Met à jour la valeur du radio sélectionné

                                                                // if (
                                                                //     i?.value ===
                                                                //     2
                                                                // ) {
                                                                //     method.setValue(
                                                                //         "part_time_percentage",
                                                                //         100
                                                                //     ); // Si on sélectionne id=2, met part_time_percentage à 100
                                                                // }
                                                            }}
                                                            items={CUMUL_CONGES.map(
                                                                ({
                                                                    id,
                                                                    name,
                                                                }) => ({
                                                                    key: id,
                                                                    value: id,
                                                                    label:
                                                                        id === 1
                                                                            ? `${name} ${
                                                                                  method.watch(
                                                                                      "part_time_percentage"
                                                                                  ) ||
                                                                                  contract_data?.part_time_percentage
                                                                              }%`
                                                                            : name,
                                                                    disabled:
                                                                        id ===
                                                                            1 &&
                                                                        method.watch(
                                                                            "part_time_percentage"
                                                                        ) ===
                                                                            100,

                                                                    // Désactive si 100%
                                                                })
                                                            )}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Flex>
                                    </Flex>
                                    <Flex
                                        hAlign="center"
                                        gap="gap.medium"
                                        styles={{ marginTop: "24px" }}
                                    >
                                        <Button
                                            content={"Annuler"}
                                            onClick={() =>
                                                _setModeUpdate(false)
                                            }
                                            flat
                                        />
                                        <Button
                                            content={
                                                "Enregistrer les modifications"
                                            }
                                            onClick={_handleSubmit}
                                            loading={is_loading_mutate}
                                            disabled={!method.formState.isValid}
                                            primary
                                            flat
                                        />
                                    </Flex>
                                </form>
                            </FormProvider>
                        }
                    />
                </Card>
            </Flex>
        );
    }

    // * MODE READ
    // * MODE READ
    // * MODE READ
    return (
        <Flex fill styles={{ maxWidth: "440px" }} column>
            <Card column>
                <Card.Title
                    canEdit={isHR}
                    content={"Temps de travail"}
                    onEdit={() => {
                        if (!isHR) {
                            return;
                        }
                        _setModeUpdate(true);
                        return;
                    }}
                />
                {/* temps de travail & salaire */}
                <Card.Body
                    content={
                        <TimeJobAndSalaryContent
                            cumulate_balance_prorata={
                                contract_data?.cumulate_balance_prorata
                            }
                            activity_rate={contract_data?.activity_rate}
                            part_time_percentage={
                                contract_data?.part_time_percentage
                            }
                            package_type={contract_data?.package_type}
                            hour_count_per_week={
                                contract_data?.hour_count_per_week
                            }
                            day_count_per_year={
                                contract_data?.day_count_per_year
                            }
                            rtt_policy={contract_data?.rtt_policy}
                            leave_policy={contract_data?.leave_policy}
                            salary={contract_data?.salary}
                            contract_country={contract_data?.contract_country}
                            timetable={contract_data?.timetable}
                        />
                    }
                />
            </Card>
        </Flex>
    );
};

export default TimeJobAndSalary;

const InputSuffix = styled(Input)`
    .ui-input__icon {
        right: 0;
        padding-inline: 8px;
        background-color: #c7c7c7;
        border-radius: 0px 4px 4px 0px;
        color: black;
    }
`;

const RadioGroupStyle = styled(RadioGroup)`
    .ui-radiogroup__item__label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
